import React from 'react'
import { useTranslation } from 'react-i18next'
import { Separator, LayoutBand, Image, H3, H5, Subheading } from '@fs/zion-ui'
import { cdnRoot } from '../../services/services'

export default function TempleRecommendQuestionsYouth() {
  const [t] = useTranslation()

  return (
    <main>
      <Separator />
      <LayoutBand maxWidth="xs">
        <Image
          alt={t('temple-recommend-questions-youth.recommend', 'Temple Recommend')}
          src={`${cdnRoot}/connect/informational/temple_recommend_youth.png`}
        />
        <Separator />
        <section>
          <H3>
            {t('informational.temple.youth.recommend.questions.heading', 'Getting a Temple Recommend')}
            <Subheading>
              {t(
                'informational.temple.youth.recommend.questions.subheading',
                "When you get your temple recommend, you will have an interview with your bishop or branch president. You can ask him anything you want. You can also have a parent come with you, if you'd like. Here are some of the things he will talk about with you."
              )}
            </Subheading>
          </H3>
          <Separator />
          <H5>{t('informational.temple.youth.recommend.questions.questions', 'Temple Recommend Questions')}</H5>
          <ol>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question1',
                'Do you have faith in Heavenly Father, Jesus Christ, and the Holy Ghost?'
              )}
            </li>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question2',
                "Do you have a testimony of Jesus Christ's Atonement and in the Restoration of His Church?"
              )}
            </li>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question3',
                'Do you sustain (support) your Church leaders (like the prophet, the apostles, and your bishop)?'
              )}
            </li>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question4',
                'Do you strive (try hard) to keep your mind and body clean and pure?'
              )}
            </li>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question5',
                'Do you follow the teachings of the Church of Jesus Christ in how you treat others?'
              )}
            </li>
            <li>
              {t('informational.temple.youth.recommend.questions.question6', 'Do you strive to keep the Sabbath holy?')}
            </li>
            <li>{t('informational.temple.youth.recommend.questions.question7', 'Do you strive to be honest?')}</li>
            <li>
              {t('informational.temple.youth.recommend.questions.question8', 'Do you pay a full 10-percent tithing?')}
            </li>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question9',
                'Do you understand and obey the Word of Wisdom?'
              )}
            </li>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question10',
                'Are there any serious sins you need to repent of?'
              )}
            </li>
            <li>
              {t(
                'informational.temple.youth.recommend.questions.question11',
                "Do you feel you are worthy to enter the Lord's house?"
              )}
            </li>
          </ol>
        </section>
        <Separator />
      </LayoutBand>
    </main>
  )
}
